import React from 'react'
import { TrendingUp, TrendingDown, Minus, Loader2 } from 'lucide-react'

const themes = {
  blue:      { border: '#3b82f6', glow: 'rgba(59,130,246,0.3)',   bg: 'rgba(59,130,246,0.05)',   icon: 'text-blue-400',    val: '#93c5fd' },
  green:     { border: '#10b981', glow: 'rgba(16,185,129,0.3)',   bg: 'rgba(16,185,129,0.05)',   icon: 'text-emerald-400', val: '#6ee7b7' },
  red:       { border: '#f43f5e', glow: 'rgba(244,63,94,0.3)',    bg: 'rgba(244,63,94,0.05)',    icon: 'text-rose-400',    val: '#fda4af' },
  amber:     { border: '#f59e0b', glow: 'rgba(245,158,11,0.3)',   bg: 'rgba(245,158,11,0.05)',   icon: 'text-amber-400',   val: '#fcd34d' },
  slate:     { border: '#64748b', glow: 'rgba(100,116,139,0.2)',  bg: 'rgba(100,116,139,0.04)',  icon: 'text-slate-400',   val: '#94a3b8' },
  purple:    { border: '#a78bfa', glow: 'rgba(167,139,250,0.3)',  bg: 'rgba(167,139,250,0.05)',  icon: 'text-violet-400',  val: '#c4b5fd' },
  // legacy aliases
  primary:   { border: '#3b82f6', glow: 'rgba(59,130,246,0.3)',   bg: 'rgba(59,130,246,0.05)',   icon: 'text-blue-400',    val: '#93c5fd' },
  success:   { border: '#10b981', glow: 'rgba(16,185,129,0.3)',   bg: 'rgba(16,185,129,0.05)',   icon: 'text-emerald-400', val: '#6ee7b7' },
  danger:    { border: '#f43f5e', glow: 'rgba(244,63,94,0.3)',    bg: 'rgba(244,63,94,0.05)',    icon: 'text-rose-400',    val: '#fda4af' },
  info:      { border: '#3b82f6', glow: 'rgba(59,130,246,0.3)',   bg: 'rgba(59,130,246,0.05)',   icon: 'text-blue-400',    val: '#93c5fd' },
  secondary: { border: '#64748b', glow: 'rgba(100,116,139,0.2)',  bg: 'rgba(100,116,139,0.04)',  icon: 'text-slate-400',   val: '#94a3b8' },
}

export default function MetricCard({ title, value, icon, trend = 'stable', color = 'blue', subtitle, loading }) {
  const t = themes[color] || themes.blue

  const TrendIcon =
    trend === 'up'   ? TrendingUp :
    trend === 'down' ? TrendingDown : Minus

  const trendColor =
    trend === 'up'   ? 'text-emerald-500' :
    trend === 'down' ? 'text-rose-500'    : 'text-slate-700'

  return (
    <div
      className="rounded-xl relative overflow-hidden transition-all duration-200 hover:translate-y-px"
      style={{
        background: `linear-gradient(135deg, ${t.bg} 0%, #111827 55%)`,
        border: '1px solid #1f2937',
        borderTop: `1.5px solid ${t.border}`,
        boxShadow: `0 -2px 12px ${t.glow}, 0 1px 3px rgba(0,0,0,0.4)`,
      }}
    >
      {/* Top glow haze */}
      <div
        className="absolute inset-x-0 top-0 h-10 pointer-events-none"
        style={{ background: `linear-gradient(to bottom, ${t.border}22, transparent)` }}
      />

      <div className="relative p-4 flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p
            className="text-slate-600 uppercase"
            style={{ fontSize: '0.65rem', letterSpacing: '0.12em', fontWeight: 600 }}
          >
            {title}
          </p>

          <div className="mt-2 flex items-baseline gap-2">
            {loading ? (
              <Loader2 className="h-5 w-5 animate-spin text-slate-700" />
            ) : (
              <p
                className="text-2xl font-bold truncate tabular-nums"
                style={{ color: t.val, fontFamily: 'JetBrains Mono, monospace' }}
              >
                {value ?? '—'}
              </p>
            )}
          </div>

          {subtitle && (
            <p className="mt-1.5 text-slate-600" style={{ fontSize: '0.7rem' }}>
              {subtitle}
            </p>
          )}
        </div>

        <div className="flex flex-col items-end gap-2 ml-3 flex-shrink-0">
          <div className={t.icon}>{icon}</div>
          {trend !== 'stable' && (
            <TrendIcon className={`h-3.5 w-3.5 ${trendColor}`} />
          )}
        </div>
      </div>
    </div>
  )
}
